import * as React from "react";
import { makeStyles } from "@fluentui/react-components";
import { BRAND } from "../risikoanalyseStep/tokens";

/**
 * Schmale goldene Fortschrittsleiste, die am oberen Rand der Aktions-Fußleiste
 * der Kontaktanlage sitzt. Sie füllt sich anhand der ausgefüllten Pflichtfelder
 * (`filled` / `total`) — analog zur Progressbar im Analysemodus, hier in Gold
 * und nur für Pflichtfelder. 100 % entspricht exakt dem `requiredOk`-Gate des
 * Speichern-Buttons. Reine Präsentation, kein Datenzugriff.
 */

const useStyles = makeStyles({
  track: {
    height: "5px",
    width: "100%",
    backgroundColor: BRAND.borderDashed,
    overflow: "hidden",
  },
  fill: {
    height: "100%",
    backgroundColor: BRAND.gold,
    transitionProperty: "width",
    transitionDuration: "240ms",
    transitionTimingFunction: "ease",
  },
});

export function RequiredFieldsProgress({
  filled,
  total,
}: {
  filled: number;
  total: number;
}) {
  const s = useStyles();
  const safeTotal = total > 0 ? total : 1;
  const clamped = Math.max(0, Math.min(filled, total));
  const pct = Math.round((clamped / safeTotal) * 100);
  return (
    <div
      className={s.track}
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={total}
      aria-valuenow={clamped}
      aria-label="Ausgefüllte Pflichtfelder"
    >
      <div className={s.fill} style={{ width: `${pct}%` }} />
    </div>
  );
}

export default RequiredFieldsProgress;
